import { Paper } from '@mui/material';
import { useIntl } from 'react-intl';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MDBox from 'components/MDBox';
import { GridCards } from 'components/Cards/GridCards';
import {
  useDeleteKnowledgeBaseMutation,
  useGetKnowledgeBasesQuery
} from 'services/knowledgeBaseApi';
import IndeterminateLoading from 'components/Loading/IndeterminateLoading';
import KnowledgeBaseDetailsDrawer from 'pages/knowledgeBase/components/knowledgeBaseDetailsDrawer';
import { useNotification } from 'hook/useNotification';

export function KnowledgeBase() {
  const navigate = useNavigate();
  const { addNotification } = useNotification();
  const { formatMessage: msg } = useIntl();

  const [knowledgeBaseDrawerOpen, setKnowledgeBaseDetailDrawerOpen] = useState(false);
  const [selectedKnowledgeBase, setKnowledgeBase] = useState(null);

  const [deleteKnowledgeBase] = useDeleteKnowledgeBaseMutation();

  const {
    data: knowledgeBases,
    isLoading: knowledgeBaseLoading,
    error: knowledgeBaseError
  } = useGetKnowledgeBasesQuery();

  if (knowledgeBaseLoading) {
    return (
      <IndeterminateLoading
        sx={{ width: '100%', color: '#125688' }}
        message={msg({ id: 'loading.configuration' })}
      />
    );
  }

  if (knowledgeBaseError)
    try {
      addNotification({
        type: 'error',
        title: msg({ id: 'notification.warning.title' }),
        message: msg({ id: 'page.knowledgeBase.fetch.error' })
      });
    } catch {
      // Ignore exception
    }

  const cardItems = knowledgeBases?.map((knowledgeBase) => ({
    id: knowledgeBase.id,
    label: knowledgeBase.label,
    description: knowledgeBase.description,
    icon: knowledgeBase.icon,
    color: knowledgeBase.color
  }));

  const handleEdit = (id) => {
    setKnowledgeBase(knowledgeBases.find((knowledgeBase) => knowledgeBase.id === id));
    setKnowledgeBaseDetailDrawerOpen(true);
  };
  const handleCreate = () => {
    setKnowledgeBase(null);
    setKnowledgeBaseDetailDrawerOpen(true);
  };

  const handleDelete = (id) => {
    deleteKnowledgeBase(id)
      .unwrap()
      .then(() => {
        addNotification({
          type: 'success',
          title: msg({ id: 'notification.success.title' }),
          message: msg({ id: 'page.KnowledgeBases.delete.success' })
        });
      })
      .catch((error) => {
        console.error(error);
        addNotification({
          type: 'error',
          title: msg({ id: 'notification.error.title' }),
          message: msg({ id: 'page.KnowledgeBases.delete.error' })
        });
      });
  };

  const handleSelect = (knowledgeBaseId) => {
    navigate(`/portal/knowledgeBase/${knowledgeBaseId}/documents`);
  };

  return (
    <>
      <MDBox sx={{ display: 'flex', flex: 1 }}>
        <Paper
          elevation={2}
          sx={{
            flex: 1,
            borderRadius: '10px',
            p: 2,
            mb: 1,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <GridCards
            defaultIcon="school"
            items={cardItems}
            onCreate={handleCreate}
            onDelete={handleDelete}
            onUpdate={handleEdit}
            onSelect={handleSelect}
          />
        </Paper>
      </MDBox>
      <KnowledgeBaseDetailsDrawer
        drawerOpen={knowledgeBaseDrawerOpen}
        setDrawerOpen={setKnowledgeBaseDetailDrawerOpen}
        knowledgeBase={selectedKnowledgeBase}
      />
    </>
  );
}
